import { useMemo } from "react";
import { useAppStore } from "@/stores";
import { revealContent } from "@/campaigns/registry";
import { PrizeRevealWindowFor } from "./prize-reveal-card";

/**
 * The reveal window with the panel closed (Sebastian, 2026-10-22: "when
 * clicking the prize reveal it now opens up the dashboard and the prize
 * reveal — it should only play the prize reveal"): the in-game button's
 * Reveal Prize claims the win without opening the panel, and this — mounted
 * at the widget's root beside the toasts, outside the open/closed gate —
 * plays the window for the campaign whose reveal is under way. With the panel
 * open, the campaign's reveal card owns the window instead (one owner at a
 * time).
 */
export function ClosedPanelReveal() {
  // The reveal under way: the shown campaign's (the one the player tapped)
  // first, else any other with disclosed rows — never a stale failed batch
  // elsewhere blocking it (👺 Belmont, B1).
  const key = useAppStore((s) => {
    const batches = s.revealBatchByCampaign;
    const tapped = s.selectedCampaignId;
    if (tapped && batches[tapped]) return tapped;
    return (
      Object.keys(batches).find((k) => batches[k].status === "revealed") ?? null
    );
  });
  // Read once per reveal: the reel freezes its landing plan on mount, so a
  // later change to the campaign's prizes can't reach it anyway.
  const content = useMemo(
    () => (key ? revealContent(useAppStore.getState(), key) : null),
    [key]
  );
  if (!content) return null;
  return (
    <PrizeRevealWindowFor
      key={content.campaign.id}
      campaign={content.campaign}
      reveal={{ prizes: content.prizes }}
    />
  );
}
